import { fromColorPathToColor, WeenatColor } from '@weenat/theme'
import { BarChart } from '../icons/generic-icons'

const DEFAULT_DOT_SIZE = 8
const DEFAULT_SQUARE_SIZE = 12
const LINE_HEIGHT = 4

export interface ChartLegendSymbolProps {
  variant: 'square' | 'dot' | 'line' | 'dashed-line' | 'bars'
  color?: WeenatColor
  size?: number
}

const ChartLegendSymbol: FC<ChartLegendSymbolProps> = ({
  variant,
  color = 'grayscale.black',
  size
}) => {
  const finalSize = variant === 'dot' ? (size ?? DEFAULT_DOT_SIZE) : (size ?? DEFAULT_SQUARE_SIZE)

  return variant === 'dot' ? (
    <Box $width={finalSize} $height={finalSize} $borderRadius='100%' $backgroundColor={color} />
  ) : variant === 'square' ? (
    <Box $backgroundColor={color} $width={finalSize} $height={finalSize} $borderRadius='sm' />
  ) : variant === 'line' ? (
    <Box $backgroundColor={color} $height={LINE_HEIGHT} $width={finalSize} $borderRadius='sm' />
  ) : variant === 'dashed-line' ? (
    <Flex
      $flexDirection='row'
      $gap={2}
      $alignItems='center'
      $height={LINE_HEIGHT}
      $width={finalSize}
    >
      <Box $backgroundColor={color} $flex={1} $height={LINE_HEIGHT} $borderRadius='sm' />
      <Box $backgroundColor={color} $flex={1} $height={LINE_HEIGHT} $borderRadius='sm' />
    </Flex>
  ) : variant === 'bars' ? (
    <BarChart fill={fromColorPathToColor(color)} height={finalSize + 4} />
  ) : null
}

export default ChartLegendSymbol
